/* DSPEEDY v3 motion: scroll reveals, carousels, tilt, header state, count-up. No dependencies. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document.documentElement;
  doc.classList.add('v3-js');

  /* 1. Scroll reveals (also tags common Dawn blocks so every page breathes) */
  var auto = '.dsp-collection-head, .product-grid .grid__item, .dsp-pdp .product__info-container > *, .collapsible-content .accordion, .newsletter__wrapper, .footer-block, .dsp-band__media, .dsp-band__copy, .dsp-lineup__car, .dsp-process__step, .dsp-chips, .dsp-index__group, .dsp-sr .dsp-title-block';
  function tag() {
    document.querySelectorAll(auto).forEach(function (el, i) {
      if (!el.hasAttribute('data-v3-reveal')) { el.setAttribute('data-v3-reveal', ''); el.style.setProperty('--d', ((i % 8) * 50) + 'ms'); }
    });
  }
  function observe() {
    var els = document.querySelectorAll('[data-v3-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }
  tag(); observe();
  /* Dawn re-renders grids on filter/sort: re-tag */
  new MutationObserver(function () { tag(); observe(); }).observe(document.body, { childList: true, subtree: true });

  /* 2. Carousels */
  document.querySelectorAll('[data-v3-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-v3-track]'); if (!track) return;
    var prev = root.querySelector('[data-v3-prev]'), next = root.querySelector('[data-v3-next]');
    function step(dir) { var item = track.querySelector('li'); var w = item ? item.getBoundingClientRect().width + 20 : 300; track.scrollBy({ left: dir * w * 2, behavior: reduce ? 'auto' : 'smooth' }); }
    function state() { if (!prev || !next) return; prev.disabled = track.scrollLeft < 8; next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', state, { passive: true }); state();
  });

  /* 3. Tilt on category tiles (pointer devices only) */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('[data-v3-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg'); el.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%'); el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }

  /* 4. Header: condensed state after scroll + hero parallax */
  var hero = document.querySelector('[data-v3-hero]'); var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY; doc.classList.toggle('v3-scrolled', y > 24);
      if (hero && !reduce && y < 1200) hero.style.setProperty('--sy', y.toFixed(0));
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* 5. Hero entrance */
  if (hero) { var go = function () { hero.classList.add('is-live'); }; setTimeout(go, 80); requestAnimationFrame(go); }
  /* Safety net: never leave content hidden if observers are throttled (background tabs). */
  setTimeout(function () { if (document.hidden) document.querySelectorAll('[data-v3-reveal]').forEach(function (e) { e.classList.add('is-in'); }); }, 2500);
})();
